import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getTabClasses = () => {
  const classes = [
    "flex",
    "flex-col",
    "group",
    "outline-none",
    "relative",
    "focus-visible:border-secondary-300",
    "hover:cursor-pointer",
    "focus-visible:shadow-focus-secondary-md"
  ];
  return concatClasses(classes);
};
const getPaginationItemClasses = (placement) => {
  const classes = ["pagination-item", "inline-block", "truncate"];
  if (placement === "vertical") {
    classes.push("p-14", "flex", "items-start", "flex-col", "justify-center");
  } else {
    classes.push("p-14", "flex", "items-center", "flex-col");
  }
  return concatClasses(classes);
};
const getTitleClasses = (isSelected, placement) => {
  const classes = ["dsf-text-s-medium"];
  if (placement === "vertical") {
    classes.push("text-start");
  } else {
    classes.push("text-center");
  }
  if (isSelected) {
    classes.push("text-secondary-300");
  } else {
    classes.push("text-neutral-500");
  }
  return concatClasses(classes);
};
const getSelectedIndicatorClasses = (placement) => {
  const classes = ["bg-secondary-300", "absolute"];
  if (placement === "vertical") {
    classes.push(...["w-4", "h-full", "rounded-r-full", "left-0"]);
  } else {
    classes.push(...["h-4", "w-full", "rounded-t-full", "bottom-0"]);
  }
  return concatClasses(classes);
};
const getBaseIndicatorClasses = (placement) => {
  const classes = ["hidden", "group-hover:block", "bg-neutral-200", "absolute"];
  if (placement === "vertical") {
    classes.push(...["h-full", "w-4", "rounded-r-full", "left-0"]);
  } else {
    classes.push(...["w-full", "h-4", "rounded-t-full", "bottom-0"]);
  }
  return concatClasses(classes);
};
export {
  getBaseIndicatorClasses,
  getPaginationItemClasses,
  getSelectedIndicatorClasses,
  getTabClasses,
  getTitleClasses
};
